import type { SVGProps } from "react";

/**
 * checkmark-2
 * @category Interface General
 */
export default function IconCheckmark2(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox='0 0 24 24' fill='none' aria-hidden {...props}>
      <path
        d='M2.75 15.0938L9 20.25L21.25 3.75'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}
